import { render, staticRenderFns } from "./sfc-header-no-ad.vue?vue&type=template&id=3cdecd10&lang=pug&"
import script from "./sfc-header-no-ad.vue?vue&type=script&lang=js&"
export * from "./sfc-header-no-ad.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports